import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.46967 11.0303C8.76256 11.3232 9.23744 11.3232 9.53033 11.0303L12.5303 8.03033C12.8232 7.73744 12.8232 7.26256 12.5303 6.96967C12.2374 6.67678 11.7626 6.67678 11.4697 6.96967L9 9.43934L6.53033 6.96967C6.23744 6.67678 5.76256 6.67678 5.46967 6.96967C5.17678 7.26256 5.17678 7.73744 5.46967 8.03033L8.46967 11.0303Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }